import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IMultipleContentTypeResult } from '~src/httpClient/serverApi/types/IResponse';
import { MoveContentToContainerParams } from '~src/projects/ServerApi/requests/MoveContentToContainerRequest';

export class RestoreContentToContainerRequest extends Request<MoveContentToContainerParams, IMultipleContentTypeResult> {
  constructor(params: MoveContentToContainerParams) {
    super('restoreArchivedContentToContainer', params);
  }
}